import React from 'react';
import { connect } from 'react-redux';
import { getSafe } from '@/helpers/global';

class ApplyTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0
    }
  }

  render() {
    const { language } = this.props;
    const { activeStep } = this.state;
    return (
      <React.Fragment>
        <section className="terms-container">
          <div className="title">
            {getSafe(() => language.ipo_apply_terms_title)}
          </div>
          <div className="content">
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_statement }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_1 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_2 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_3 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_4 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_a }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_b }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_c }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_d }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_e }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_5_f }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_6 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_7 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_8 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_9 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_9_a }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_9_b }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10_a }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10_b }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10_c }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10_d }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_10_e }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_11 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_12 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_13 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_14 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_a }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_b }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_c }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_d }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_e }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_f }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_15_g }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16_a }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16_b }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16_c }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16_d }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_16_e }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_17 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_18 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_19 }}/>
            <p dangerouslySetInnerHTML={{ __html: language.ipo_apply_terms_20 }}/>
          </div>
        </section>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(ApplyTerms)
